import React from 'react';

import './SearchFilterContainer.scss';

function SearchFilterContainer({ children }) {
  return <div styleName="container">{children}</div>;
}

export default React.memo(SearchFilterContainer);
